<script setup>
	import { computed } from 'vue';
	import { DsText } from '@coloplast/design-system';
	import SendCampaignIdCtaButton from 'shared/components/actionButtonWithCTA/SendCampaignIdCtaButton.vue';

	const props = defineProps({
		vm: {
			type: Object,
			default: () => {},
		},
		isInlineLayout: {
			type: Boolean,
			default: () => false,
		},
	});

	const isButtonShown = computed(() => (!props.vm?.CurrentBlock?.FormArea && props.vm?.BaseViewModel?.CtaButtonLinkUrl && props.vm?.CurrentBlock?.CtaButtonText) || (props.vm?.CurrentBlock?.FormArea && !props.vm?.BaseViewModel?.IsFormPresented && props.vm?.BaseViewModel?.CtaButtonLinkUrl))

	const ctaButtonVariant = computed(() => {
		if (props.vm.BaseViewModel?.CtaButtonVariant) {
			return props.vm.BaseViewModel.CtaButtonVariant;
		} else if (props.vm.CurrentBlock?.FormArea && !props.vm.BaseViewModel?.IsFormPresented) {
			return 'primary';
		} else {
			return 'secondary-neutral';
		}
	});
</script>

<template>
	<article
		class="c-cta-block__card"
		:class="{ '--fullwidth': !isInlineLayout, '--inline': isInlineLayout }"
	>
		<div
			 class="c-cta-block__content"
			 :class="{ '--fullwidth': !isInlineLayout, '--inline': isInlineLayout, '--left-aligned' : vm.CurrentBlock.MediaAlignType == 0 }"
			 >
			<DsText
					v-if="vm.CurrentBlock.SubheadingText"
					class="c-cta-block__subheading"
					html-element="h4"
					:text-style="isInlineLayout ? 'medium' : 'regular'"
					:text-type="isInlineLayout ? 'body-sm' : 'body-md'"
					>
				{{ vm.CurrentBlock.SubheadingText }}
			</DsText>
			<DsText
					v-if="vm.CurrentBlock.HeadingText"
					html-element="h3"
					:text-type="isInlineLayout ? 'heading-xl' : 'heading-3xl'"
					class="c-cta-block__heading"
					:class="{
					'--no-description' : vm.CurrentBlock.SubheadingText && !vm.CurrentBlock.ShortDescription,
					'--headline-only': !vm.CurrentBlock.SubheadingText && !vm.CurrentBlock.ShortDescription
				}"
					>
				{{ vm.CurrentBlock.HeadingText }}
			</DsText>
			<h3
				v-if="(vm.CurrentBlock.HeadingTextLineOne || vm.CurrentBlock.HeadingTextLineTwo) && !vm.CurrentBlock.HeadingText"
				class="c-cta-block__heading"
				:class="{ '--headline-only': !vm.CurrentBlock.SubheadingText && !vm.CurrentBlock.ShortDescription }"
				>
				<DsText
						html-element="span"
						:text-type="isInlineLayout ? 'heading-xl' : 'heading-3xl'">
					{{ vm.CurrentBlock.HeadingTextLineOne }}
				</DsText>
				<DsText
						html-element="span"
						:text-type="isInlineLayout ? 'heading-xl' : 'heading-3xl'"
						>
					{{ vm.CurrentBlock.HeadingTextLineTwo }}
				</DsText>
			</h3>
			<DsText
					v-if="vm.CurrentBlock.ShortDescription"
					class="c-cta-block__description"
					text-style="regular"
					:text-type="isInlineLayout ? 'body-sm' : 'body-md'"
					>
				{{ vm.CurrentBlock.ShortDescription }}
			</DsText>
			<!--if no formkit or formkit form submitted-->
			<SendCampaignIdCtaButton
				v-if="isButtonShown"
				:vm="vm"
				:is-inline-layout="isInlineLayout"
				:openInNewWindow="vm.CurrentBlock.FormArea && !vm.BaseViewModel.IsFormPresented"
				:variant="ctaButtonVariant"
			/>
			<!--formKit popup-->
			<slot></slot>
		</div>
		<template v-if="vm.BaseViewModel.DesktopImageUrl">
			<div
				v-if="isInlineLayout"
				class="c-cta-block__image-wrapper"
			>
				<img
					:src="`${vm.BaseViewModel.DesktopImageUrl}?im=Resize=(322,228)`"
					:alt="vm.CurrentBlock.ImageAltText || vm.CurrentBlock.HeadingTextLineOne"
					class="c-cta-block__image --inline"
				/>
			</div>
			<picture
				v-else
				class="c-cta-block__media"
			>
				<source
					v-if="vm.BaseViewModel.MobileImageUrl"
					media="(max-width: 767px)"
					:srcset="`${vm.BaseViewModel.MobileImageUrl}?im=Resize=(375,213)`"
				/>
				<img
					:src="`${vm.BaseViewModel.DesktopImageUrl}?im=Resize=(624,400)`"
					:alt="vm.CurrentBlock.ImageAltText || vm.CurrentBlock.HeadingText"
					class="c-cta-block__image"
				/>
			</picture>
		</template>
	</article>
</template>
